import { render, staticRenderFns } from "./CustomDoughnutChartWrapper.vue?vue&type=template&id=a940df42&"
import script from "./CustomDoughnutChartWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomDoughnutChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports